var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.color,"small":""}},[_vm._v("mdi-circle")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }